import { Routes } from '@angular/router';
import { TAGS_HOME } from 'src/app/shared/seo.tags';

export const homeRoutes: Routes = [
    {
        path: '',
        title: TAGS_HOME.title,
        data: { description: TAGS_HOME.description },
        loadComponent: () => import('./home.component').then(c => c.HomeComponent)
    }
];
